<template>
  <div id="app">
    <head-top :logo="siteLogo" :usercenterUrl="siteUsercenterUrl" :userName="userName" :siteUrl="siteUrl"
      :siteAppUrl="siteAppUrl" :siteResUrl="siteResUrl" :userImg="userImg" :headData="headData">
    </head-top>
    <router-view :mainData.sync="mainData" />
    <!-- <big-data></big-data> -->
    <foot-bottom :copyRight="siteCopyright" :footerData="footerData"></foot-bottom>
    <message v-show="isShowMessage" :msg="msg" @isShowMsg="isShowMsg" :isShowMessage="isShowMessage"></message>
    <!-- <footer></footer> -->
  </div>
</template>

<script>
  import headTop from '@/components/headtop/headTop.vue'
  // import footBottom from './components/footBottom/footBottom.vue'
  import footBottom from '@/components/footBottom/footer.vue'
  import message from '@/components/Message/Message'
  import api from '@/utils/api.js'
  import cookie from '@/assets/getCookie.js'
  // import bigData from './components/indexContent/bigData.vue'
  export default {
    name: 'Home',
    data() {
      return {
        ipConfig: '',
        siteLogo: null,
        siteCopyright: null,
        siteUsercenterUrl: null,
        websiteId: null,
        siteUsercenterUrl: null,
        siteUsermanageUrl: null,
        userName: null,
        schoolId: null,
        userId: null,
        thirdToken: null,
        third: null,
        siteUrl: null,
        siteAppUrl: null,
        siteResUrl: null,
        isRouterAlive: true,
        userType: null,
        tabName: null, // 路由名字
        userImg: null,
        title: '爱学云',
        headImg: null,
        headData: null, // 头部配置信息
        footerData: null, // footer配置信息
        mainData: null, // 主体配置信息
        adminType: null,
        isShowMessage: false,
        msg: null
      }
    },
    created() {
      let host = window.location.hostname
      this.ipConfig = host

      // console.log(this.third,"kikiki")
    },
    watch: {
      // $route(val,oldval){
      //   console.log(val,oldval,"luyoutiaozhuan")
      //   if(val.path == '/iframe'){
      //     console.log("zoule aaaaaaa")
      //     $("#headtop").hide();
      //     $("#footerbox").hide();
      //   }else {
      //     $("#headtop").show();
      //     $("#footerbox").show();
      //   }
      // }
      '$route': {
        handler(to, from) {
          setTimeout(() => { // 避免首次获取不到window._czc
            if (window._czc) {
              let location = window.location
              let contentUrl = location.pathname + location.hash
              let refererUrl = '/'
              // 用于发送某个URL的PV统计请求，
              // console.log(contentUrl,'wwwwww')
              window._czc.push(['_setAutoPageview', false])
              window._czc.push(['_trackPageview', contentUrl, refererUrl])
            }
          }, 300)
        },
        immediate: true // 首次进入页面即执行
      }
    },
    mounted() {
      this.getMsg()

    },
    methods: {
      getMsg() {
        const that = this
        const url = '/axt-website/website/getWebsiteInfoByUrl'
        const params = {
          url: 'http://' + this.ipConfig,
          type: 'all'
        }
        api.getListAPI(url, params).then(res => {
          if (res.data.message === 'success') {
            that.siteLogo = res.data.data.siteLogo
            that.siteCopyright = res.data.data.siteCopyright
            that.siteUsercenterUrl = res.data.data.siteUsercenterUrl
            that.siteUsermanageUrl = res.data.data.siteUsermanageUrl
            that.websiteId = res.data.data.id
            that.siteUrl = res.data.data.siteUrl
            that.siteAppUrl = res.data.data.siteAppUrl
            that.siteResUrl = res.data.data.siteResUrl
            that.title = res.data.data.siteName
            // 设置临时ico logo title
            // window.document.title = that.title // 设置title
            // const link = document.querySelector("link[rel*='icon']") || document.createElement('link')
            // link.type = 'image/x-icon'
            // link.rel = 'shortcut icon'
            // link.href = this.$configUrl.lsPath + res.data.data.siteIco
            // document.getElementsByTagName('head')[0].appendChild(link)
            //
            localStorage.setItem('title', that.title)
            localStorage.setItem('websiteId', that.websiteId)
            localStorage.setItem('siteLogo', that.siteLogo)
            localStorage.setItem('siteCopyright', that.siteCopyright)
            localStorage.setItem('siteUsercenterUrl', that.siteUsercenterUrl)
            localStorage.setItem('siteUsermanageUrl', that.siteUsermanageUrl)
            localStorage.setItem('siteUrl', that.siteUrl) // 首页
            localStorage.setItem('siteAppUrl', that.siteAppUrl) // 应用市场
            localStorage.setItem('siteResUrl', that.siteResUrl) // 教学资源
            localStorage.setItem('siteDomain', res.data.data.siteDomain) // 教学资源
            that.getHpStyleByWebsiteId(that.websiteId)
            const cookie_token = cookie.getCookie('AXY_' + that.websiteId + '_access_token')
            if (cookie_token && cookie_token !== 'null') {
              that.userName = decodeURI(escape(cookie.getCookie('AXY_' + that.websiteId + '_user_name')));
              that.schoolId = cookie.getCookie('AXY_' + that.websiteId + '_school_id')
              that.userId = cookie.getCookie('AXY_' + that.websiteId + '_user_id')
              that.userType = cookie.getCookie('AXY_' + that.websiteId + '_user_type')
              that.thirdToken = cookie.getLoginCookie('AXY_' + that.websiteId + '_token').replace(/"/g, '')
              that.adminType = cookie.getCookie('AXY_' + that.websiteId + '_adminType')
              if (cookie.getCookie('AXY_' + that.websiteId + '_head_img')) { //是否有头像
                that.userImg = cookie.getCookie('AXY_' + that.websiteId + '_head_img')
                localStorage.setItem('userImg', that.userImg);
              }
              localStorage.setItem('userName', that.userName);
              localStorage.setItem('schoolId', that.schoolId);
              localStorage.setItem('userId', that.userId);
              localStorage.setItem('userType', that.userType);
              localStorage.setItem('accessToken', cookie_token);
              localStorage.setItem('thirdToken', that.thirdToken)
              localStorage.setItem('adminType', that.adminType)
              that.third = that.$route.query.third
              var backUrl = window.location.host
              if (that.third == 'student') {
                if (that.userType == 'teacher') {
                  that.isShowMessage = true
                  that.msg = ('您没有权限进入')
                  return false
                }
                window.location.href = that.$configUrl.stuPath + '/thirdDocking/login?token=' + that.thirdToken
              } else if (that.third == 'teacher') {
                if (that.userType != 'teacher') {
                  that.isShowMessage = true
                  that.msg = ('您没有权限进入')
                  return false
                }
                window.open(that.$configUrl.teacherPath + '/loading.html?token=' + cookie_token + '&backurl=' +
                  backUrl)
              } else if (that.third == 'manager') {
                if (that.userType != 'teacher') {
                  that.isShowMessage = true
                  that.msg = ('您没有权限进入')
                  return false
                }
                window.open('http://' + that.siteUsermanageUrl.replace('managecenter', 'manage'))
              }

            } else {
              console.log('no cookie2')
            }

          }
        })
      },
      getHpStyleByWebsiteId(id) {
        const that = this
        const url = '/axt-website/hp/getHpStyleByWebsiteId'
        const params = {
          website_id: id
        }
        api.getListAPI(url, params).then(res => {
          console.log('data', res)
          if (res.data.message === 'success') {
            window.document.title = res.data.data.name // 设置title
            const link = document.querySelector("link[rel*='icon']") || document.createElement('link')
            link.type = 'image/x-icon'
            link.rel = 'shortcut icon'
            if (res.data.data.iconPath.indexOf('http') === -1) {
              link.href = this.$configUrl.futureImgUrl + res.data.data.iconPath
            } else {
              link.href = res.data.data.iconPath
            }
            document.getElementsByTagName('head')[0].appendChild(link)
            that.headData = res.data.data.header
            that.footerData = res.data.data.footer
            that.mainData = res.data.data.body
            console.log(that.mainData, 'kkkkk')
            localStorage.setItem('iconPath', res.data.data.iconPath)
          }
        })
      },
      headBg(msg) {
        this.headbackground = msg
      },
      isShowMsg(msg) {
        this.isShowMessage = false
      }
    },
    components: {
      headTop,
      footBottom,
      message
    }
  }
</script>

<style>
  #app {
    font-family: -apple-system, BlinkMacSystemFont, Microsoft YaHei, Gordita, proximanova, Helvetica Neue, Helvetica, Arial, sans-serif, Segoe UI, Roboto, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #34495E;
    font-size: 16px;
    font-weight: 400;
    min-width: 1200px !important;
    cursor: default;
  }

  @media screen and (max-width: 1440px) {
    #app {
      zoom: 0.9;
    }
  }

  #content {
    width: 87.5%;
    margin: 0 auto;
  }

  .fl {
    float: left;
  }

  .fr {
    float: right;
  }

  .font13 {
    font-size: 13px;
  }

  .font14 {
    font-size: 14px;
  }

  .font16 {
    font-size: 16px;
  }

  .font17 {
    font-size: 17px;
  }

  .font18 {
    font-size: 18px;
  }

  .font20 {
    font-size: 20px;
  }

  .font22 {
    font-size: 22px;
  }

  .font24 {
    font-size: 24px;
  }

  .font28 {
    font-size: 28px;
  }

  .font30 {
    font-size: 30px;
  }

  .t_center {
    text-align: center;
  }

  #newsDetail table,
  #newsDetail table tr,
  #newsDetail table td,
  #newsDetail table th {

    border: 1px solid #555;
  }

  #newsDetail table tr {
    min-height: 15px;
  }

  .title {
    padding-top: 50px;
    font-size: 30px;
    font-weight: 500;
    color: #444444;
  }

  .titlebtm {
    width: 73px;
    height: 3px;
    background: #3583FF;
    margin: 10px auto 0;
  }

  .graybg {
    background: #F8F9FB;
  }

  .clear {
    clear: both;
  }

  .pointer {
    cursor: pointer;
  }

  .clearfix {
    zoom: 1;
    display: block;
  }

  .clearfix:after {
    content: ".";
    display: block;
    height: 0;
    clear: both;
    visibility: hidden;
  }

  .bg {
    height: 80px;
    width: 100%;
    position: absolute;
    left: 0;
    top: 0;
    background-color: #3583FF;
  }

  /* 页码 */
  .page {
    margin: 40px 0;
    text-align: center;
  }

  .page .ivu-page-item {
    background: #F0F0F0;
    border: none;
    width: 40px;
    height: 40px;
    line-height: 40px;
    margin-right: 20px;
  }

  .page .ivu-page-next,
  .page .ivu-page-prev {
    border: none;
    background: #F0F0F0;
    width: 40px;
    height: 40px;
    line-height: 40px;
    margin-right: 20px;
  }

  .page .ivu-page-next:hover,
  .page .ivu-page-prev:hover {
    background: #DEEBFF;
  }

  .page .ivu-page-item-active {
    background: #3583FF;
    color: #ffffff;
  }

  .page .ivu-page-item a {
    color: #99A1A7;
  }

  .page .ivu-page-item-active a,
  .page .ivu-page-item-active:hover a {
    color: #ffffff
  }

  .page .ivu-page-item:hover {
    background: #DEEBFF;
    border: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/home/home.vue